import { V1, serializeQueryString } from 'Util/fetcher';

// Account
//

// https://ajaib.readme.io/reference/check-account-active-fe
export const dtAccountStatusUrl = `${V1}stock/odt/account`;
// https://ajaib.readme.io/reference/get-cached-balance
// https://ajaib.readme.io/reference/get-balance-by-ticker-code
export const dtTradelimitByStockCodeUrl = (code) => {
  if (!code) return `${V1}stock/odt/balance/`;
  return `${V1}stock/odt/balance/stock-haircut/${serializeQueryString({ code })}`;
};

// Config
//

/**
 * https://ajaib.readme.io/reference/get-param
 * @param {'ODT_PANIC_ACTIVATION'|'ODT_PANIC_CASH_TRANSFER'|'ODT_PANIC_BUY_SELL'} key
 */
export const dtSysParamUrl = (key) => `${V1}stock/odt/admin/system-param/${key}`;

// https://ajaib.readme.io/reference/get-stock-multiplier-list
export const dtMultiplierListUrl = `${V1}stock/odt/stock-tradable/multiplier`;
// https://ajaib.readme.io/reference/get-stock-multiplier
export const dtMultiplierByCodeUrl = (code) => `${V1}stock/odt/stock-tradable/multiplier/${code}`;

// https://ajaib.readme.io/reference/check-elibility-odt-stock
export const dtEnabledByStockCodeUrl = (code) => `${V1}stock/odt/stock-tradable/${code}`;

// Trading
//

/**
 * - Buy:       https://ajaib.readme.io/reference/buy-stock-odt
 * - Sell:      https://ajaib.readme.io/reference/sell-stock-1
 * - Amend:     https://ajaib.readme.io/reference/amend-stock-odt
 * - Withdraw:  https://ajaib.readme.io/reference/withdraw-order-odt
 *
 * @param {'buy'|'sell'|'amend'|'withdraw'} type
 */
export const dtPostOrderUrl = (type) => `${V1}stock/odt/order/${type}/`;


// Portfolio
//

// https://ajaib.readme.io/reference/portofolio-odt
export const dtPortfolioListUrl = `${V1}stock/odt/portfolio`;
// https://ajaib.readme.io/reference/order-list-with-filter-feature-odt
export const dtOrderOpenUrl = `${V1}stock/odt/order/orderlist-filter/`;
// https://ajaib.readme.io/reference/tradelist-odt
export const dtOrderHistoryUrl = `${V1}stock/odt/order/historytrade-filter/`;
